import React from 'react'

export default function Permission() {
  return (
    <>
      <div className="d-flex flex-column w-100 justify-content-center align-items-center" style={{ height: '70vh' }}>
        <h1>ขอโทษครับ</h1>
        <div>คุณไม่ได้รับสิทธิ์ ในการเข้าถึงหน้านี้</div>
      </div>
    </>
  )
}
